import Vue from "vue";
import VueTypedJs from 'vue-typed-js'
import _ from "lodash";
import App from "@/App.vue";
import router from "@/router";
import store from "@/store";
import utils from "./utils";
import "./registerServiceWorker";
import "./plugins/element.js";
import "./style/main.styl";

Vue.config.productionTip = false;
Vue.prototype._ = _;
Vue.prototype.$utils = utils;

Vue.use(VueTypedJs)

new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount("#app");
